import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const removeDoubleDots = (value: unknown): any => {
  if (typeof value === 'string') {
    return value.replaceAll('...', '…').replaceAll('..', '.');
  }

  if (typeof value === 'object' && value != null) {
    if (Array.isArray(value)) {
      const result: any[] = [];
      for (let keyIndex = 0; keyIndex < value.length; keyIndex++) {
        result[keyIndex] = removeDoubleDots(value[keyIndex]);
      }

      return result;
    } else {
      const keys = Object.keys(value);
      const result: { [key: string]: any } = {};
      for (let keyIndex = 0; keyIndex < keys.length; keyIndex++) {
        const key = keys[keyIndex];
        result[key] = removeDoubleDots((value as { [key: string]: any })[key]);
      }

      return result;
    }
  }

  return value;
};

export const init18next = () => {
  return i18next
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .use({
      type: 'postProcessor',
      name: 'removeDoubleDots',
      process: removeDoubleDots,
    })
    .init({
      fallbackLng: false,
      load: 'currentOnly',
      lowerCaseLng: true,
      backend: {
        loadPath: '/infohub/locales/{{lng}}/{{ns}}.json',
      },
      detection: {
        // Language is derived from the URL path, so caching is unnecessary.
        caches: [],
        order: ['path'],
        lookupFromPathIndex: 1,
      },
      interpolation: {
        escapeValue: false, // not needed for react!!
      },
      postProcess: ['removeDoubleDots'],
    });
};
